function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import { Card as CardDSM, Flex } from '@goodrx/matisse-react';
import { getDataAttributes } from '@goodrx/x-core';
import { CdnImage } from '../../../../components/CdnImage';
export const Card = /*#__PURE__*/forwardRef(({
  className,
  sys: {
    id
  },
  displayTitle,
  image,
  url,
  attributes
}, linkRef) => /*#__PURE__*/React.createElement("a", _extends({
  className: className,
  key: id,
  href: url || undefined,
  target: "_blank",
  rel: "noopener noreferrer",
  "aria-label": displayTitle || 'Unnamed Link',
  ref: linkRef
}, getDataAttributes(attributes)), /*#__PURE__*/React.createElement(CardDSM, {
  key: id,
  height: "100%"
}, /*#__PURE__*/React.createElement(CardDSM.Body, {
  height: "100%"
}, /*#__PURE__*/React.createElement(Flex, {
  height: "100%",
  alignItems: "center",
  justifyContent: "center"
}, image && /*#__PURE__*/React.createElement(CdnImage, {
  style: {
    width: '100%',
    maxWidth: 75
  },
  alt: (image === null || image === void 0 ? void 0 : image.title) || 'Unnamed Image',
  src: `${image === null || image === void 0 ? void 0 : image.url}`
}))))));